<div class="card card-table mb-0" style="background-color: #EDF5FB !important;margin-top: 20px;">
  <span class="booking-heading">Booking Details</span>
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-inline-flex align-items-center gap-2" style="margin-left: 15px;">
        <label for="pageSizeSelect" class="form-label mb-0">Show:</label>
        <select id="pageSizeSelect" class="form-select form-select-sm" style="width: auto;"
          (change)="onChangePageSize()" [(ngModel)]="paginationPageSize">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        Entries
      </div>
      <div class="d-inline-flex align-items-center gap-2 ">
        <input type="text" matInput autocomplete="off" #filtertextbox (keyup)="onFilterTextBoxChanged()"
          placeholder="Search.." class="search-box" style="width: 240px;border-radius: 14px;" />
      </div>
    </div>

    <ag-grid-angular #agGrid class="ag-theme-alpine" style="width: 100%; height: 600px;" [rowData]="rowData"
      [gridOptions]="gridOptions" [columnDefs]="colDefs" [rowDragManaged]="true" [rowHeight]="50" [headerHeight]="50"
      [suppressPaginationPanel]="true" [pagination]="true" (gridReady)="onGridReady($event)"
      [paginationPageSize]="paginationPageSize" [tooltipShowDelay]="tooltipShowDelay"
      [tooltipHideDelay]="tooltipHideDelay" (paginationChanged)="onPaginationChanged()">
    </ag-grid-angular>

    <div class="table-footer-container">
      <div class="record-info">
        <ng-container *ngIf="SerachedRow; else noSearchContent">
          Records: {{ currPage && currPage > 0 ? (currPage - 1) * paginationPageSize + 1 : 0 }} to
          {{ currPage * paginationPageSize > SerachedRow ? SerachedRow : currPage * paginationPageSize
          }} of
          {{ SerachedRow || SerachedRow === 0 ? SerachedRow : (NoRecordsFound ? 0 : rowData?.length) }}
        </ng-container>
        <ng-template #noSearchContent>
          Records: {{ currPage && currPage > 0 ? (currPage - 1) * paginationPageSize + 1 : 0 }} to
          {{ currPage * paginationPageSize > rowData?.length ? rowData?.length : currPage *
          paginationPageSize
          }} of
          {{ SerachedRow || SerachedRow === 0 ? SerachedRow : (NoRecordsFound ? 0 : rowData?.length) }}
        </ng-template>
      </div>
      <div class="paging-records">Total Pages: {{totalPage}}</div>
      <div class="pagination-wrapper">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" (click)="onBtPrevious()" [ngClass]="{disabled: currPage === 1}">
              Previous
            </a>
          </li>
          <li *ngFor="let page of paging" class="page-item">
            <a class="page-link" (click)="gotoPage(page)" [class.active]="page === currPage">
              {{ page }}
            </a>
          </li>
          <li class="page-item">
            <a class="page-link" (click)="onBtNext()" [ngClass]="{disabled: currPage === totalPages}">
              Next
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>